/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendWorkingCapitalParameterDto } from '../../models/backend-working-capital-parameter-dto';
import { BackendWorkingCapitalParameterRequestDto } from '../../models/backend-working-capital-parameter-request-dto';

export interface FinancingSourcesWorkingCapitalParametersCreate$Params {
  body: BackendWorkingCapitalParameterRequestDto;
}

export function financingSourcesWorkingCapitalParametersCreate(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesWorkingCapitalParametersCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesWorkingCapitalParametersCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendWorkingCapitalParameterDto>;
    }),
  );
}

financingSourcesWorkingCapitalParametersCreate.PATH = '/api/financing_sources/working_capital_parameters/';
